export default __webpack_public_path__ + "assets/webgl/scene-3.220cb3ff.glb";